import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../theme/palette';

const style = () =>
  createStyles({
    root: {
      marginTop: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    competences: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      '@media (max-width: 425px)': {
        flexDirection: 'column',
        alignItems: 'stretch'
      }
    },
    competenceBlock: {
      userSelect: 'none',
      color: palette.text.white,
      background: palette.common.primaryBlue,
      fontWeight: 500,
      fontSize: '0.875rem',
      padding: '15px',
      borderRadius: palette.borderRadius.default
    },
    textCompetenceBlock: {
      margin: '0'
    },
    finDeQuizAnswerContainer: {
      margin: '10px',
      padding: '5px',
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      backgroundColor: palette.background.underBox,
      borderRadius: '10px',
      '& > h2': {
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '0.875rem',
        lineHeight: '24px',
        color: palette.text.primary
      },
      '& > p': {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '0.75rem',
        lineHeight: '24px',
        color: palette.text.primary
      }
    },
    emptyAnswersContainer: {
      display: 'flex',
      justifyContent: 'center'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
